import { combineReducers } from 'redux';
import ehubReducer from './ehubReducer';
import myPrivilegesReducer from './myPrivilegesReducer';

export default combineReducers({
  ehub: ehubReducer,
  myPrivileges: myPrivilegesReducer,
});
